<div class="body">
  <h2 class="title">Transaction expired</h2>
  <hr />
  <p class="text">The transaction has expired, please try again.</p>
  <mat-dialog-actions>
    <button type="text" (click)="close()" class="btn btn-secondary btnClose">CLOSE</button>
  </mat-dialog-actions>
</div>
